export default __webpack_public_path__ + "img/2bb061a04676d04215320979152e5e88.png";